import { ManagePracticeService } from './../../manage-practice/manage-practice.service';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CustomLoadingService } from '../custom-loading/custom-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { CustomValidators } from '../Validators/custom-validators';


@Component({
  selector: 'app-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.css']
})
export class AddressComponent implements OnInit {
  address1: any = ""
  address2: any = ""
  state: any = ""
  city: any = ""
  contact: any = ""
  fax: any = ""
  zipcode: any = ""
  ext: any = ""
  submit: any = ""

  private address: any = []
  error: any
  public title: string = "Address";
  public addressForm: FormGroup;
  translationKey = "Address"
  @Input() addressType: string
  @Input() options: any = []
  @Input() showSameAsMailingLink: any = false;
  @Output()
  submitAddressForm: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private loadingService: CustomLoadingService,
    private formBuilder: FormBuilder,
    private managePracticeService: ManagePracticeService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute) {

    this.addressForm = this.formBuilder.group({
      "AddressLine1": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "AddressLine2": [''],
      "City": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "State": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Zipcode": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator, , Validators.minLength(5)])],
      "Contact": ['', Validators.compose([Validators.required, CustomValidators.nospaceValidator])],
      "Fax": ['', Validators.compose([CustomValidators.nospaceValidator])],
      "ContactExtension": ['', Validators.compose([CustomValidators.nospaceValidator])]
    });

  }

  ngOnInit() {
    this.activatedRoute.data.subscribe((data: { address: any }) => {

      this.address = data.address;

      if (this.address) {
        this.BindForm();
      
      }
    });
    this.address1 = this.translate.instant(this.translationKey + ".AddressLine1.Label")
    this.address2 = this.translate.instant(this.translationKey + ".AddressLine2.Label")
    this.state = this.translate.instant(this.translationKey + ".State.Label")
    this.city = this.translate.instant(this.translationKey + ".City.Label")
    this.contact = this.translate.instant(this.translationKey + ".Contact.Label")
    this.fax = this.translate.instant(this.translationKey + ".Fax.Label")
    this.zipcode = this.translate.instant(this.translationKey + ".Zipcode.Label")
    this.submit = this.translate.instant("Common.Edit")
    this.title = this.translate.instant(this.translationKey + ".DialogTitle")
    this.ext = this.translate.instant(this.translationKey + ".ContactExt.Label")

    this.translate.onLangChange.subscribe(() => {
      this.address1 = this.translate.instant(this.translationKey + ".AddressLine1.Label")
      this.address2 = this.translate.instant(this.translationKey + ".AddressLine2.Label")
      this.state = this.translate.instant(this.translationKey + ".State.Label")
      this.city = this.translate.instant(this.translationKey + ".City.Label")
      this.contact = this.translate.instant(this.translationKey + ".Contact.Label")
      this.fax = this.translate.instant(this.translationKey + ".Fax.Label")
      this.zipcode = this.translate.instant(this.translationKey + ".Zipcode.Label")
      this.submit = this.translate.instant("Common.Submit")
      this.title = this.translate.instant(this.translationKey + ".DialogTitle")
      this.ext = this.translate.instant(this.translationKey + ".ContactExt.Label")
    })


  }
  @Output("parentFun") parentFun: EventEmitter<any> = new EventEmitter();
  submitForm() {
    if (this.addressForm.valid) {
      this.parentFun.emit(this.addressForm);
    }
  }

  getBillingOrMailingAddress(addressType) {
    this.loadingService.show();
    this.managePracticeService.getProviderAddress(addressType).subscribe(res => {
      this.address = res;
      if (this.address) {

        this.BindForm();
      }


    }, () => { this.loadingService.hide() }, () => {
      this.loadingService.hide();
    })


  }
  BindForm() {

    this.addressForm.get("AddressLine1").setValue(this.address.Address1);
    this.addressForm.get("AddressLine2").setValue(this.address.Address2);
    this.addressForm.get("City").setValue(this.address.City);
    this.addressForm.get("State").setValue(this.address.State);
    this.addressForm.get("Contact").setValue(this.address.ContactNumber);
    this.addressForm.get("Zipcode").setValue(this.address.Zipcode);
    this.addressForm.get("Fax").setValue(this.address.Fax);
    this.addressForm.get("ContactExtension").setValue(this.address.ContactNumberExt);


  }



}
